angular.module('zc.zenclerkS')
  .component('zcsTagUnset', {
    templateUrl: '/templates/zenclerk_s/directives/zcs_tag_unset/zcs_tag_unset.html',
    bindings: {},
    controllerAs: 'vm',
    controller: ZcsTagUnsetController,
  });

ZcsTagUnsetController.$inject = ['$state', '$stateParams', 'Devise', 'ZcsProject'];
function ZcsTagUnsetController($state, $stateParams, Devise, ZcsProject) {
  const vm = this;
  ZcsProject.get(Devise.currentUser.id, $stateParams.apikey)
    .then(project => {
      vm.project = project;
      vm.trackingTagSettingPage = $state.href('zenclerkS.project.tags.tracking', { projectId: project.project_id });
      vm.conversionTagSettingPage = $state.href('zenclerkS.project.tags.conversion', { projectId: project.project_id });

      if(project.tracking_tag_confirmed_at && project.conversion_tag_confirmed_at) {
        $state.go('zenclerkS.project.dashboard', { apikey: project.apikey });
      }
    });
}



// WEBPACK FOOTER //
// ./src/zenclerk_s_modules/zenclerk_s/directives/zcs_tag_unset/zcs_tag_unset.js